export default __webpack_public_path__ + "static/media/Mask Group 1@2x.0fbbd21c.png";